var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundingArrowsCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28224",
    "data-name": "Group 28224",
    transform: "translate(-1659 -3536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8716",
    "data-name": "Path 8716",
    d: "M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    transform: "translate(1659 3536)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_refresh-2",
    "data-name": "vuesax/outline/refresh-2",
    transform: "translate(1300 3225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-2",
    transform: "translate(364 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.11,14.44v2.424",
    transform: "translate(0.398 -6.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.7,4.848A4.85,4.85,0,0,1,4.848,9.7C2.172,9.7.538,7,.538,7H2.73M0,4.848A4.838,4.838,0,0,1,4.848,0,5.964,5.964,0,0,1,9.7,2.7m0,0V.272M9.7,2.7H7.544",
    transform: "translate(0.97 0.97)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H11.636V11.636H0Z",
    fill: "none",
    opacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundingArrowsCircle);
export default __webpack_public_path__ + "static/media/rounding_arrows-circle.ac1b0732913f9249bb55ce52edcbf00d.svg";
export { ForwardRef as ReactComponent };